import yup from '@/app/utils/customisedYup';

export const emailValidator = () =>
  yup
    .string()
    .trim()
    .max(80, 'Email must be 80 characters or less')
    .emailValidation()
    .required('Email is required.');

export const firstNameValidator = () =>
  yup
    .string()
    .trim()
    .max(40, 'First name must be 40 characters or less')
    .required('First name is required.');

export const lastNameValidator = () =>
  yup
    .string()
    .trim()
    .max(80, 'Last name must be 80 characters or less')
    .required('Last name is required.');

export const phoneNumberValidator = () =>
  yup
    .string()
    .trim()
    .max(15, 'Phone number must be 15 characters or less')
    .required('Phone number is required.');

export const permissionValidator = message => yup.boolean().oneOf([true], message);
